import useGet from "api/useGet";
import { bodyScroll_clear, bodyScroll_limit } from "js/function";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function HeaderLink(data){
    return (
        <button type="button" onClick={()=>{data.func()}} className={`header_link ${data.addClass ? data.addClass : ""}`} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.contents}}/>
    );
}

function SideMenuLink(data){
    return (
        <button type="button" onClick={()=>{data.func()}} className={`sideMenu_link ${data.addClass ? data.addClass : ""}`} disabled={data.disabled ? data.disabled : false} dangerouslySetInnerHTML={{__html:data.contents}}/>
    );
}

function HeaderCsBox(data){
    return (
        <div className="header_csBox">
            <div className="header_csText header_csItem"><span className="header_csTextItem">고객센터</span><a href="tel:064-711-3200" className="wbTextColor">064-711-3200</a></div>
            <a href="https://pf.kakao.com/_BZnxbn" target="_blank" className="header_csBtn header_csItem"><img src="/assets/images/sns/kakao_plus.svg"/></a>
        </div>
    );
}

function Header(headerData){
    let navigate = useNavigate();
    const [menuOpen,setMenuOpen] = useState(false);

    function closePopup(){
        bodyScroll_clear();
        setMenuOpen(false);
    }
    
    useEffect(() => {
        if(menuOpen){
            bodyScroll_limit();
        }else{
            bodyScroll_clear();
        }
    }, [menuOpen]);

    return (
        <div className="header">
            <div className="pcheader">
                <div className="header_csArea">
                    <HeaderCsBox/>
                </div>
                <div className="headerSection">
                    <div className="headerArea headerArea_left">
                        <button type="button" onClick={()=>{navigate("/")}} className="headerLogo">
                            <img src="/assets/images/img/logo.png"/>
                        </button>
                    </div>
                    <div className="header_linkArea">
                        <HeaderLink
                            addClass={headerData?.activeType === 0 ? "active" : ""} 
                            contents="렌터카 차량조회"
                            func={()=>{navigate("/rent/list")}}
                        />
                        <HeaderLink
                            addClass={headerData?.activeType === 1 ? "active" : ""} 
                            contents="예약확인"
                            func={()=>{
                                if(localStorage.getItem("token")){
                                    navigate("/reservation")
                                }else{
                                    window.welComeOpen("nonMember")
                                }
                            }}
                        />
                        <HeaderLink
                            addClass={headerData?.activeType === 2 ? "active" : ""} 
                            contents="고객센터"
                            func={()=>{navigate("/event")}}
                        />
                        <HeaderLink
                            addClass={headerData?.activeType === 3 ? "active" : ""}
                            contents="자주 찾는 질문"
                            func={()=>{navigate("/faq")}}
                        />
                        <HeaderLink
                            addClass={headerData?.activeType === 4 ? "active" : ""}
                            contents="마이페이지"
                            func={()=>{navigate("/mypage")}}
                        />
                    </div>
                    <div className="headerArea headerArea_right">
                        <button type="button" onClick={()=>{
                            if(localStorage.getItem("token")){
                                window.logOut();
                            }else{
                                window.welComeOpen();
                            }
                        }} className="header_memberBtn">
                            <div className="header_memberBtn_itemsBox">
                                <div className="header_memberBtn_items">
                                    {localStorage.getItem("token") ? "로그아웃" : "로그인/회원가입"}
                                    <img src="/assets/images/icon/btn_move.svg"/>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>        
            </div>
            <div className="mheader">
                <div className={`headerSection ${headerData.addClass ? headerData.addClass : ""}`}>
                    {!headerData.pageBack || headerData.pageBack === "" ? "" : <button type="button" className="btnBack btnHeaderLeft" onClick={(e) => headerData.func(e)}><img src="/assets/images/basic/back.svg"/></button>}
                    {headerData.logo ? <button type="button" className="btnLogo btnHeaderLeft" onClick={(e) => navigate("/")}><img src="/assets/images/img/logo.png"/></button> : ""}
                    {headerData.headTitle ? <p className={`headTitle ${headerData.centerTitle ? "centerTitle" : ""} ${headerData.titleClass ? headerData.titleClass : ""}`} dangerouslySetInnerHTML={{__html:headerData.headTitle}}/> : ""}
                    {headerData.mMenu ? 
                        <button type="button" onClick={()=>setMenuOpen(true)} className={`btnHeaderRight btnMenuOpen ${menuOpen ? "active" : ""}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    :""}
                    {headerData.rightBtnsArr ? 
                        <div className="headerInfoBox btnHeaderRight">
                            {headerData.rightBtnsArr.map((item, i) => (
                                <Fragment key={i}>
                                    {item.type !== "img" ?
                                    <button type="button" className={`btnHeaderRightItem ${item.addClass ? item.addClass : ""}`} onClick={(e) => {item.func()}} dangerouslySetInnerHTML={{__html:item.contents}}></button>
                                    :
                                    <button type="button" className={`btnHeaderRightItem ${item.addClass ? item.addClass : ""}`} onClick={(e) => {item.func()}}><img src={item.contents}/></button>
                                    }
                                </Fragment>
                            ))}
                        </div>
                        : ""
                    }
                    {headerData.pageClose ? <button type="button" className="btnClose btnHeaderRight" onClick={(e) => {headerData.closeFunc(e)}}><img src="/assets/images/basic/close.svg"/></button> : ""}
                    {headerData.children}
                </div>
                <div className={`sideCover ${menuOpen ? "active" : ""}`} onClick={()=>{closePopup()}}></div>
                <div className={`sideMenu ${menuOpen ? "active" : ""}`}>
                    <div className="sideMenu_section">
                        <div className="sideMenu_area">
                            <button type="button" onClick={()=>{navigate("/")}} className="btnLogo">
                                <img src="/assets/images/img/logo.png"/>
                            </button>
                            <SideMenuLink
                                addClass={headerData?.activeType === 0 ? "active" : ""} 
                                contents="렌터카 차량조회"
                                func={()=>{navigate("/rent/list");closePopup()}}
                            />
                            <SideMenuLink
                                addClass={headerData?.activeType === 1 ? "active" : ""} 
                                contents="예약확인"
                                func={()=>{
                                    if(localStorage.getItem("token")){
                                        navigate("/reservation")
                                    }else{
                                        window.welComeOpen("nonMember")
                                    }
                                    closePopup()
                                }}
                            />
                            <SideMenuLink
                                addClass={headerData?.activeType === 2 ? "active" : ""} 
                                contents="고객센터"
                                func={()=>{navigate("/faq");closePopup()}}
                            />
                            <SideMenuLink
                                addClass={headerData?.activeType === 3 ? "active" : ""}
                                contents="자주 찾는 질문"
                                func={()=>{navigate("/faq");closePopup()}}
                            />
                            <SideMenuLink
                                addClass={headerData?.activeType === 4 ? "active" : ""}
                                contents="마이페이지"
                                func={()=>{navigate("/mypage");closePopup()}}
                            />
                            <SideMenuLink
                                contents={localStorage.getItem("token") ? "로그아웃" : "로그인/회원가입"}
                                func={()=>{
                                    if(localStorage.getItem("token")){
                                        window.logOut();
                                    }else{
                                        window.welComeOpen();
                                    }
                                    closePopup();
                                }}
                            />
                        </div>
                    </div>
                    <div className="sideMenu_subSection">
                        <HeaderCsBox/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export {Header};